import LtiAuthProvider, { useAuth as LTIUseAuth } from 'contexts/ltiAuth';
import PasswordAuthProvider, { useAuth as PasswordUseAuth } from 'contexts/passwordAuth';

const useAuth = () => {
    const IS_LTI = process.env.REACT_APP_AUTH === 'LTI';
    return IS_LTI ? LTIUseAuth() : PasswordUseAuth();
};

const AuthProvider = ({ children }) => {
    const IS_LTI = process.env.REACT_APP_AUTH === 'LTI';
    return IS_LTI ? (
        <LtiAuthProvider>{children}</LtiAuthProvider>
    ) : (
        <PasswordAuthProvider>{children}</PasswordAuthProvider>
    );
};

export { useAuth };
export default AuthProvider;
